export default __webpack_public_path__ + "supermarketcd2755.png";